import React from 'react'
import List from '@components/LocalMerchant/JukeTreasure/List'
import Apply from '@components/LocalMerchant/JukeTreasure/Apply'
import Example from '@components/LocalMerchant/JukeTreasure/Example'
import View from '@components/LocalMerchant/JukeTreasure/View'
import Pay from '@components/LocalMerchant/JukeTreasure/Pay'
import Record from '@components/LocalMerchant/JukeTreasure/Record'
import Rule from '@components/LocalMerchant/JukeTreasure/Rule'
import Explain from '@components/LocalMerchant/JukeTreasure/Explain'
import Enroll from '@components/LocalMerchant/JukeTreasure/Enroll'
import Buy from '@components/LocalMerchant/JukeTreasure/Buy'
import OldList from '@components/LocalMerchant/JukeTreasure/List_old'
import NewEnroll from '@components/LocalMerchant/JukeTreasure/NewEnroll'
import ProductIntro from '@common/ProductIntro'
import JiaMengHeader from '@components/JiaMeng/Header/MarketingCenter'
import { PRODUCT_JUKE } from '@constant'

export default {
  path: 'jukeTreasure',
  component: JiaMengHeader,
  indexRoute: {
    component: List
  },
  stat: '聚客宝/首页',
  childRoutes: [
    {
      path: 'intro',
      component: props => <ProductIntro {...props} id={PRODUCT_JUKE} />
    },
    {
      path: 'apply',
      component: Apply,
      stat: '聚客宝/申请活动'
    },
    {
      path: 'example',
      component: Example,
      stat: '聚客宝/活动范例'
    },
    {
      path: 'view/:id',
      component: View,
      stat: '聚客宝/活动详情'
    },
    {
      path: 'pay',
      component: Pay,
      stat: '聚客宝/活动点购买'
    },
    {
      path: 'record',
      component: Record,
      stat: '聚客宝/充值记录'
    },
    {
      path: 'rule',
      component: Rule,
      stat: '聚客宝/聚客宝规则'
    },
    {
      path: 'explain',
      component: Explain,
      stat: '聚客宝/活动点说明'
    },
    {
      path: 'enroll/:id',
      component: Enroll,
      stat: '聚客宝/旧版报名信息'
    },
    {
      path: 'buy',
      component: Buy,
      stat: '聚客宝/活动点充值'
    },
    {
      path: 'old',
      component: OldList,
      stat: '聚客宝/旧版列表页'
    },
    {
      path: 'newEnroll/:id',
      component: NewEnroll,
      stat: '聚客宝/报名信息'
    }
  ]
}
